import { render } from "./SedangBerlangsungMeeting.vue?vue&type=template&id=5d65d1fd"
import script from "./SedangBerlangsungMeeting.vue?vue&type=script&lang=js"
export * from "./SedangBerlangsungMeeting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__